import { PropsWithChildren } from 'react';
import Cookies from 'js-cookie';
import { COOKIE_KEY } from '@shared/constants';

export function AuthGuard({ children }: PropsWithChildren) {
  const token = Cookies.get(COOKIE_KEY.accessToken);

  if (!token) {
    window.location.pathname = '/login'; // refresh the page and navigate to login page when there is no token
    return null;
  }
  return children;
}
